<script>
import {ref} from 'vue';

export default {
    inheritAttrs: false,
    props: {
        initial: {
            default: false,
        }
    },

    render() {
        if (!this.active) {
            return this.$slots.default({
                active: this.active,
                toggle: this.toggle,
                update: this.update,
            })
        }
        if (!!this.$slots.active) {
            return this.$slots.active({
                toggle: this.toggle
            })
        }

        return this.$slots.default({
            active: this.active,
            toggle: this.toggle,
            update: this.update,
        });
    },

    setup({initial}) {
        const active = ref(initial);

        const toggle = () => {
            active.value = !active.value;
        }

        const update = (value) => {
            active.value = value;
        }

        return {
            toggle,
            active,
            update,
        }
    },
}
</script>
